import React, { useState, useEffect } from 'react';
import OtpInput from 'react-otp-input';
import { sendForgotPassword, verifyOtp } from '../_redux/authAPI';
import { useDispatch, useSelector } from 'react-redux';
import { setResetToken } from '../_redux/authSlice';
import toasters from '../../../../utils/toasters/Toasters';

const Otp = () => {
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [timer, setTimer] = useState(60); // start 60s countdown on first load

  const dispatch = useDispatch();
  const { otpSession } = useSelector((state) => state.auth);
  const { phone_tx, username_tx, email_tx } = otpSession || {};

  // Countdown effect
  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [timer]);

  const handleVerify = async () => {
    setError(null);

    // Validate OTP input length
    if (!otp || otp.length < 5) {
      setError('Please enter all 5 digits of the OTP');
      return;
    }

     // 2. Check only numbers
    if (!/^[0-9]+$/.test(otp)) {
      setError("OTP should only contain numbers");
      return;
    }

    setLoading(true);
    try {
      const res = await verifyOtp({ phone_tx, username_tx, otp });
      if (res?.token) {
        dispatch(setResetToken(res.token));
      }
      setSuccess(true);
    } catch (err) {
      setError('Invalid OTP. Try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    setResendLoading(true);
    setError(null);
    try {
      const res = await sendForgotPassword({
        phone_tx,
        username_tx,
        email_tx,
        resend_token: true,
      });

      toasters({ type: 'success', message: res?.message || 'OTP resent successfully' });
      setTimer(60); // restart countdown
    } catch (err) {
      const errorMsg = err?.response?.data?.message || 'Could not resend OTP. Try later.';
      toasters({ type: 'error', message: errorMsg });
      setError(errorMsg);
    } finally {
      setResendLoading(false);
    }
  };

  return (
    <div className="Auth-form-container">
      <form className="Auth-form" onSubmit={(e) => e.preventDefault()}>
        <h1 className="Auth-form-title text-white px-4 py-5">Verify your code</h1>
        <div className="Auth-form-content pt-3 px-4 otpWrapper">
          {!success ? (
            <>
              <label className="text-center d-block mb-3 mt-1">
                You will get an OTP via SMS
              </label>

                    <OtpInput
                      value={otp}
                      onChange={setOtp}
                      numInputs={5}
                      renderSeparator={<span>-</span>}
                      renderInput={(props) => (
                        <input
                          {...props}
                          type="text"
                          inputMode="numeric"
                          pattern="[0-9]*"
                          maxLength={1}
                          className="otp-input"
                        />
                      )}
                    />

                 {/* Validation / API error */}
              {error && <p className="text-danger mt-1">{error}</p>}

              {/* Timer shown below OTP input */}
              {timer > 0 && (
                <p className="text-muted mt-2 text-center">
                  <b>00:{timer}s</b>
                </p>
              )}

              <div className="d-flex flex-column justify-content-center my-4 gap-2">
                <button
                  type="button"
                  onClick={handleVerify}
                  className="btn btn-primary"
                  disabled={loading}
                >
                  {loading ? 'Verifying...' : 'Verify'}
                </button>

                {/* Resend link below Verify button */}
                <p className="text-center mt-3">
                  Didn’t receive the code?{' '}
                  <span
                    style={{
                      cursor: timer > 0 ? 'not-allowed' : 'pointer',
                      textDecoration: 'underline',
                      color: timer > 0 ? 'gray' : '#0d6efd',
                      fontWeight: 500,
                    }}
                    onClick={timer === 0 && !resendLoading ? handleResend : undefined}
                  >
                    {resendLoading ? 'Sending...' : 'Resend OTP'}
                  </span>
                </p>
              </div>
            </>
          ) : (
            <p className="text-success text-center my-3">
              Password reset instructions have been sent to your email address.
            </p>
          )}
        </div>
      </form>
    </div>
  );
};

export default Otp;
